import { MCButton } from './MCButton';
import React from 'react';
import { remCss } from 'src/helpers';

export const UnreadBadge = ({ unread }) => {
  if (!unread) return null;

  if (unread.toString().length === 1) {
    return (
      <MCButton
        className={'mc-sidebar-menu-item-link-unread'}
        label={unread}
        tiny
        rounded
        style={{
          height: remCss(22),
          minWidth: remCss(22),
          cursor: 'revert',
          boxSizing: 'border-box',
          paddingTop: remCss(1)
        }}
        primary
        dark
      />
    );
  }
  return (
    <MCButton
      className={'mc-sidebar-menu-item-link-unread'}
      tiny
      rounded
      style={{
        height: remCss(22),
        minWidth: remCss(22),
        cursor: 'revert',
        boxSizing: 'border-box',
        paddingTop: remCss(1)
      }}
      primary
      dark
    >
      <span className={'mc-text-truncate'} style={{ margin: `0 ${remCss(7)}px` }}>
        {unread}
      </span>
    </MCButton>
  );
};
